import { useState, useCallback } from "react";
import { X, ArrowLeft } from "lucide-react";

const POODLE_IMAGES = [
  "https://customer-assets.emergentagent.com/job_3476f179-e28e-4a73-ad04-dc3e86ca447d/artifacts/jhuj9aso_ldsartbot_httpss.mj.runWowi96QL37o_the_poodle_dad_of_this_image_6f6633ef-37c6-490d-9aa1-8e71717fe520%20%281%29.png",
  "https://customer-assets.emergentagent.com/job_fluffy-friend-4/artifacts/ae01nwov_ldsartbot_httpss.mj.runWowi96QL37o_Create_a_cute_pastel-coloure_8933b4a2-3c9f-4656-aa3a-d936a9b83a93.png",
  "https://customer-assets.emergentagent.com/job_fluffy-friend-4/artifacts/4n0ynx1b_ldsartbot_httpss.mj.runWowi96QL37o_the_poodle_dad_of_this_image_72e5033a-93f6-48b5-b289-275a8954aee6.png",
];

const CATEGORIES = [
  { id: 'addition', label: 'Addition +', icon: '➕' },
  { id: 'takeaway', label: 'Takeaway −', icon: '➖' },
  { id: 'times', label: 'Times Table ×', icon: '✖️' },
  { id: 'divide', label: 'Divide ÷', icon: '➗' },
];

const LEVELS = [
  { id: 'easy', label: 'Easy' },
  { id: 'beginner', label: 'Beginner' },
  { id: 'normal', label: 'Normal' },
  { id: 'medium', label: 'Medium' },
  { id: 'hard', label: 'Hard' },
  { id: 'expert', label: 'Expert' },
];

const QUESTIONS_PER_ROUND = 10;

const PRAISE = [
  "Brilliant!", "Well done!", "Amazing!", "You're a star!", "Fantastic!",
  "Super!", "Great job!", "Clever!", "Perfect!", "Wonderful!"
];

const ENCOURAGE = [
  "Nearly! Try again 💛", "So close! Have another go 💛", "Oops! Try once more 💛"
];

const PoodleMaths = ({ isOpen, onClose }) => {
  const [gameState, setGameState] = useState('category');
  const [category, setCategory] = useState(null);
  const [level, setLevel] = useState(null);
  const [question, setQuestion] = useState(null);
  const [score, setScore] = useState(0);
  const [questionNum, setQuestionNum] = useState(0);
  const [feedback, setFeedback] = useState(null);
  const [streak, setStreak] = useState(0);

  const generateQuestion = useCallback((cat, lvl) => {
    let a, b, answer, op;

    if (cat === 'addition') {
      op = '+';
      if (lvl === 'easy') { a = Math.floor(Math.random() * 3) + 1; b = Math.floor(Math.random() * 3) + 1; }
      else if (lvl === 'beginner') { a = Math.floor(Math.random() * 5) + 1; b = Math.floor(Math.random() * 5) + 1; }
      else if (lvl === 'normal') { a = Math.floor(Math.random() * 8) + 2; b = Math.floor(Math.random() * 8) + 2; }
      else if (lvl === 'medium') { a = Math.floor(Math.random() * 15) + 3; b = Math.floor(Math.random() * 15) + 3; }
      else if (lvl === 'hard') { a = Math.floor(Math.random() * 30) + 5; b = Math.floor(Math.random() * 30) + 5; }
      else { a = Math.floor(Math.random() * 50) + 10; b = Math.floor(Math.random() * 50) + 10; }
      answer = a + b;
    } else if (cat === 'takeaway') {
      op = '−';
      if (lvl === 'easy') { a = Math.floor(Math.random() * 4) + 2; b = Math.floor(Math.random() * (a - 1)) + 1; }
      else if (lvl === 'beginner') { a = Math.floor(Math.random() * 7) + 3; b = Math.floor(Math.random() * (a - 1)) + 1; }
      else if (lvl === 'normal') { a = Math.floor(Math.random() * 12) + 4; b = Math.floor(Math.random() * (a - 1)) + 1; }
      else if (lvl === 'medium') { a = Math.floor(Math.random() * 20) + 5; b = Math.floor(Math.random() * (a - 1)) + 1; }
      else if (lvl === 'hard') { a = Math.floor(Math.random() * 40) + 10; b = Math.floor(Math.random() * (a - 1)) + 1; }
      else { a = Math.floor(Math.random() * 80) + 20; b = Math.floor(Math.random() * (a - 1)) + 1; }
      answer = a - b;
    } else if (cat === 'times') {
      op = '×';
      if (lvl === 'easy') { a = Math.floor(Math.random() * 2) + 1; b = Math.floor(Math.random() * 3) + 1; }
      else if (lvl === 'beginner') { a = Math.floor(Math.random() * 3) + 1; b = Math.floor(Math.random() * 5) + 1; }
      else if (lvl === 'normal') { a = Math.floor(Math.random() * 5) + 2; b = Math.floor(Math.random() * 5) + 2; }
      else if (lvl === 'medium') { a = Math.floor(Math.random() * 7) + 2; b = Math.floor(Math.random() * 7) + 2; }
      else if (lvl === 'hard') { a = Math.floor(Math.random() * 10) + 2; b = Math.floor(Math.random() * 10) + 2; }
      else { a = Math.floor(Math.random() * 12) + 2; b = Math.floor(Math.random() * 12) + 2; }
      answer = a * b;
    } else {
      op = '÷';
      let divisor, quotient;
      if (lvl === 'easy') { quotient = Math.floor(Math.random() * 3) + 1; divisor = Math.floor(Math.random() * 2) + 1; }
      else if (lvl === 'beginner') { quotient = Math.floor(Math.random() * 4) + 1; divisor = Math.floor(Math.random() * 3) + 1; }
      else if (lvl === 'normal') { quotient = Math.floor(Math.random() * 5) + 2; divisor = Math.floor(Math.random() * 5) + 2; }
      else if (lvl === 'medium') { quotient = Math.floor(Math.random() * 7) + 2; divisor = Math.floor(Math.random() * 7) + 2; }
      else if (lvl === 'hard') { quotient = Math.floor(Math.random() * 10) + 2; divisor = Math.floor(Math.random() * 10) + 2; }
      else { quotient = Math.floor(Math.random() * 12) + 2; divisor = Math.floor(Math.random() * 12) + 2; }
      a = quotient * divisor;
      b = divisor;
      answer = quotient;
    }

    // Generate wrong answers
    const wrongs = new Set();
    while (wrongs.size < 2) {
      const offset = Math.floor(Math.random() * Math.max(3, Math.floor(answer * 0.3))) + 1;
      const wrong = Math.random() > 0.5 ? answer + offset : Math.max(0, answer - offset);
      if (wrong !== answer && wrong >= 0) wrongs.add(wrong);
    }

    const options = [answer, ...wrongs].sort(() => Math.random() - 0.5);
    const poodleImg = POODLE_IMAGES[Math.floor(Math.random() * POODLE_IMAGES.length)];

    return { a, b, op, answer, options, poodleImg };
  }, []);

  const startGame = (lvlId) => {
    setLevel(lvlId);
    setScore(0);
    setQuestionNum(1);
    setStreak(0);
    setFeedback(null);
    setQuestion(generateQuestion(category, lvlId));
    setGameState('playing');
  };

  const handleAnswer = (selected) => {
    if (feedback) return;

    if (selected === question.answer) {
      const newScore = score + 1;
      const newStreak = streak + 1;
      setScore(newScore);
      setStreak(newStreak);
      setFeedback({ correct: true, message: PRAISE[Math.floor(Math.random() * PRAISE.length)] });

      setTimeout(() => {
        if (questionNum >= QUESTIONS_PER_ROUND) {
          setGameState('finished');
        } else {
          setQuestionNum(questionNum + 1);
          setQuestion(generateQuestion(category, level));
          setFeedback(null);
        }
      }, 1200);
    } else {
      setStreak(0);
      setFeedback({ correct: false, message: ENCOURAGE[Math.floor(Math.random() * ENCOURAGE.length)] });
      setTimeout(() => setFeedback(null), 1500);
    }
  };

  const getMessage = () => {
    if (score === QUESTIONS_PER_ROUND) return "Perfect score! You're a maths superstar!";
    if (score >= 8) return "Brilliant work! Nearly perfect!";
    if (score >= 6) return "Great job! Keep practising!";
    if (score >= 4) return "Good try! You're getting better!";
    return "Well done for trying! Practice makes perfect!";
  };

  const renderVisual = () => {
    if (!question) return null;
    const { a, b, op, poodleImg } = question;
    if (a > 6 || b > 6) return null;

    return (
      <div className="flex items-center justify-center gap-2 mb-4 flex-wrap">
        <div className="flex flex-wrap justify-center gap-1">
          {Array.from({ length: a }).map((_, i) => (
            <img key={`a-${i}`} src={poodleImg} alt="" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover" />
          ))}
        </div>
        <span className="text-2xl font-bold text-[#4A4A4A] mx-2">{op}</span>
        <div className="flex flex-wrap justify-center gap-1">
          {op !== '×' && Array.from({ length: b }).map((_, i) => (
            <img key={`b-${i}`} src={POODLE_IMAGES[(POODLE_IMAGES.indexOf(poodleImg) + 1) % POODLE_IMAGES.length]} alt="" className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover" />
          ))}
          {op === '×' && <span className="text-3xl font-bold text-[#4A4A4A]">{b}</span>}
        </div>
      </div>
    );
  };

  const handleClose = () => {
    setGameState('category');
    setCategory(null);
    setLevel(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[80] bg-black/30 backdrop-blur-sm overflow-y-auto">
      <div className="min-h-full flex items-center justify-center p-4 py-6">
        <div className="bg-[#FDFBF7] rounded-3xl p-4 sm:p-6 max-w-md w-full text-center shadow-2xl relative" data-testid="poodle-maths-game">
          <button onClick={handleClose} className="absolute top-4 right-4 text-[#9A9A9A] hover:text-[#4A4A4A] transition-colors z-10" data-testid="maths-close">
            <X className="w-6 h-6" />
          </button>

          <h2 className="text-xl sm:text-2xl font-bold text-[#4A4A4A] mb-3">Poodle Maths</h2>

          {/* Category Selection */}
          {gameState === 'category' && (
            <div className="py-4">
              <p className="text-4xl mb-3">🧮</p>
              <p className="text-sm text-[#6B6B6B] mb-6">Choose what to practise:</p>
              <div className="flex flex-col gap-3 max-w-xs mx-auto">
                {CATEGORIES.map((cat) => (
                  <button key={cat.id} onClick={() => { setCategory(cat.id); setGameState('level'); }}
                    data-testid={`maths-cat-${cat.id}`}
                    className="px-6 py-4 bg-[#E8D4A8] text-[#5A4A32] rounded-2xl font-semibold hover:bg-[#D9C599] transition-all hover:scale-105 flex items-center gap-3 justify-center text-base">
                    <span className="text-xl">{cat.icon}</span> {cat.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Level Selection */}
          {gameState === 'level' && (
            <div className="py-4">
              <button onClick={() => setGameState('category')} className="absolute top-4 left-4 text-[#9A9A9A] hover:text-[#4A4A4A] transition-colors">
                <ArrowLeft className="w-6 h-6" />
              </button>
              <p className="text-sm text-[#6B6B6B] mb-1">
                {CATEGORIES.find(c => c.id === category)?.label}
              </p>
              <p className="text-sm text-[#9A9A9A] mb-5">Choose your level:</p>
              <div className="flex flex-col gap-2.5 max-w-xs mx-auto">
                {LEVELS.map((lvl) => (
                  <button key={lvl.id} onClick={() => startGame(lvl.id)}
                    data-testid={`maths-lvl-${lvl.id}`}
                    className="px-6 py-3 bg-[#F9F6EE] text-[#4A4A4A] rounded-2xl font-semibold hover:bg-[#E8D4A8] transition-all hover:scale-105 text-sm border border-[#E8E5DC]">
                    {lvl.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Playing */}
          {gameState === 'playing' && question && (
            <div className="py-2">
              <div className="flex justify-center gap-6 mb-4 text-sm">
                <div className="text-center">
                  <p className="text-[#9A9A9A] text-xs">Score</p>
                  <p className="font-bold text-[#B89823]">{score}/{QUESTIONS_PER_ROUND}</p>
                </div>
                <div className="text-center">
                  <p className="text-[#9A9A9A] text-xs">Question</p>
                  <p className="font-bold text-[#4A4A4A]">{questionNum}/{QUESTIONS_PER_ROUND}</p>
                </div>
                <div className="text-center" style={{ minWidth: '50px' }}>
                  <p className="text-[#9A9A9A] text-xs">Streak</p>
                  <p className="font-bold text-[#5A8A5A]">{streak >= 3 ? `${streak} 🔥` : streak}</p>
                </div>
              </div>

              <div style={{ minHeight: '60px' }}>
                {renderVisual()}
              </div>

              <div className="bg-white rounded-2xl p-4 mb-4 border border-[#E8E5DC]">
                <p className="text-3xl sm:text-4xl font-bold text-[#4A4A4A]">
                  {question.a} {question.op} {question.b} = ?
                </p>
              </div>

              <div className="grid grid-cols-3 gap-3 mb-3">
                {question.options.map((opt, i) => (
                  <button
                    key={i}
                    onClick={() => handleAnswer(opt)}
                    data-testid={`maths-answer-${i}`}
                    className={`py-4 rounded-2xl text-2xl font-bold transition-all hover:scale-105 ${
                      feedback && feedback.correct && opt === question.answer
                        ? 'bg-[#D4EDDA] text-[#5A8A5A] ring-2 ring-[#5A8A5A]'
                        : 'bg-[#F9F6EE] text-[#4A4A4A] hover:bg-[#E8D4A8]'
                    }`}
                  >
                    {opt}
                  </button>
                ))}
              </div>

              <div style={{ minHeight: '52px' }} className="flex items-center justify-center">
                {feedback && (
                  <div className={`rounded-2xl p-3 w-full ${feedback.correct ? 'bg-[#D4EDDA]' : 'bg-[#FFF3CD]'}`}>
                    <p className={`text-sm font-semibold ${feedback.correct ? 'text-[#5A8A5A]' : 'text-[#856404]'}`}>
                      {feedback.message}
                    </p>
                  </div>
                )}
              </div>

              <button onClick={() => setGameState('level')} className="text-xs text-[#9A9A9A] underline hover:text-[#6B6B6B] mt-2">
                Change level
              </button>
            </div>
          )}

          {/* Finished */}
          {gameState === 'finished' && (
            <div className="py-4">
              <p className="text-5xl mb-3">🎉</p>
              <p className="text-xl font-bold text-[#4A4A4A] mb-2">Round Complete!</p>
              <p className="text-4xl font-bold text-[#B89823] my-3">{score}/{QUESTIONS_PER_ROUND}</p>
              <p className="text-sm font-medium text-[#4A4A4A] mb-6">{getMessage()}</p>
              <div className="flex gap-3 justify-center flex-wrap">
                <button onClick={() => startGame(level)} data-testid="maths-play-again"
                  className="px-5 py-2.5 bg-[#E8D4A8] text-[#5A4A32] rounded-full text-sm font-semibold hover:bg-[#D9C599] transition-all hover:scale-105">
                  Play Again
                </button>
                <button onClick={() => setGameState('level')}
                  className="px-5 py-2.5 bg-[#F3F0E6] text-[#6B6B6B] rounded-full text-sm font-semibold hover:bg-[#E8E5DC] transition-all">
                  Change Level
                </button>
                <button onClick={() => { setGameState('category'); setCategory(null); }}
                  className="px-5 py-2.5 bg-[#F3F0E6] text-[#6B6B6B] rounded-full text-sm font-semibold hover:bg-[#E8E5DC] transition-all">
                  Change Category
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PoodleMaths;
